<template>
  <form>
    <div class="row">
      <div class="col-lg-7">
        <h4 class="card-title">{{$t('small_technical_grants.document_upload__application_template_card_title')}}</h4>
        <a
          :href="downloadFiles[0][$i18n.locale]"
          class="ml-2 btn btn-simple btn-primary"
          >
          {{$t('small_technical_grants.document_upload__download_template_button_title')}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
        </a>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.revisionAppTemplateCompleted">{{$t('small_technical_grants.document_upload__completed_template_upload_title')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.revisionAppTemplateCompleted"
            class="upload-file"
            :file-data="GrantForm.files.technical.revisionAppTemplateCompleted"
            :is-editable="GrantForm.isRevisionEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.revisionAppTemplateCompleted"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.revisionAppTemplateConsultation">{{$t('small_technical_grants.document_upload__consultation_report_upload_title')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.revisionAppTemplateConsultation"
            class="upload-file"
            :file-data="GrantForm.files.technical.revisionAppTemplateConsultation"
            :is-editable="GrantForm.isRevisionEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.revisionAppTemplateConsultation"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.revisionAppTemplateCV">{{$t('small_technical_grants.document_upload__staffs_cv_upload_title')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.revisionAppTemplateCV"
            class="upload-file"
            :file-data="GrantForm.files.technical.revisionAppTemplateCV"
            :is-editable="GrantForm.isRevisionEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.revisionAppTemplateCV"
            >
          </upload-file>
        </div>

        <h4 class="card-title">{{$t('small_technical_grants.document_upload__applicant_declaration_card_title')}}</h4>
        <a
          :href="downloadFiles[1][$i18n.locale]"
          class="ml-2 btn btn-simple btn-primary"
          >
          {{$t('small_technical_grants.document_upload__download_template_button_title')}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
        </a>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.revisionAppDeclaration">{{$t('small_technical_grants.document_upload__declaration_signed_upload_title')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.revisionAppDeclaration"
            class="upload-file"
            :file-data="GrantForm.files.technical.revisionAppDeclaration"
            :is-editable="GrantForm.isRevisionEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.revisionAppDeclaration"
            >
          </upload-file>
        </div>

        <h4 class="card-title">{{$t('small_technical_grants.document_upload__co_applicant_mandate_card_title')}}</h4>
        <a
          :href="downloadFiles[2][$i18n.locale]"
          class="ml-2 btn btn-simple btn-primary"
          >
          {{$t('small_technical_grants.document_upload__download_template_button_title')}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
        </a>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.revisionAppCoApplicantMandate">{{$t('small_technical_grants.document_upload__co_applicant_mandate_upload_title')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.revisionAppCoApplicantMandate"
            class="upload-file"
            :file-data="GrantForm.files.technical.revisionAppCoApplicantMandate"
            :is-editable="GrantForm.isRevisionEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.revisionAppCoApplicantMandate"
            >
          </upload-file>
        </div>

        <!--<h4 class="card-title">{{$t('small_technical_grants.document_upload__esms_questionnaire_card_title')}}</h4>-->
        <h4 class="card-title">{{$t('small_technical_grants.4_logical_frame_work')}}</h4>
        <a
          :href="downloadFiles[3][$i18n.locale]"
          class="ml-2 btn btn-simple btn-primary"
          >
          {{$t('small_technical_grants.document_upload__download_template_button_title')}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
        </a>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.revisionAppLogicalFramework">{{$t('small_technical_grants.document_upload__esms_questionnaire_upload_title')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.revisionAppLogicalFramework"
            class="upload-file"
            :file-data="GrantForm.files.technical.revisionAppLogicalFramework"
            :is-editable="GrantForm.isRevisionEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.revisionAppLogicalFramework"
            >
          </upload-file>
        </div>

        <h4 class="card-title">{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_card_title')}}</h4>
        <a
          :href="downloadFiles[4][$i18n.locale]"
          class="ml-2 btn btn-simple btn-primary"
          >
          {{$t('small_technical_grants.document_upload__download_template_button_title')}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
        </a>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.revisionAppDueDiligenceQuestionnaire">{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_upload_title')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.revisionAppDueDiligenceQuestionnaire"
            class="upload-file"
            :file-data="GrantForm.files.technical.revisionAppDueDiligenceQuestionnaire"
            :is-editable="GrantForm.isRevisionEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.revisionAppDueDiligenceQuestionnaire"
            >
          </upload-file>
        </div>
        <h6>{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_assoc_title')}}</h6>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.revisionAppIncorporationArticles">{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_assoc_upload_title_1')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.revisionAppIncorporationArticles"
            class="upload-file"
            :file-data="GrantForm.files.technical.revisionAppIncorporationArticles"
            :is-editable="GrantForm.isRevisionEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.revisionAppIncorporationArticles"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.revisionAppInCountryRegistration">{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_assoc_upload_title_2')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.revisionAppInCountryRegistration"
            class="upload-file"
            :file-data="GrantForm.files.technical.revisionAppInCountryRegistration"
            :is-editable="GrantForm.isRevisionEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.revisionAppInCountryRegistration"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.revisionAppTaxCertification">{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_assoc_upload_title_3')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.revisionAppTaxCertification"
            class="upload-file"
            :file-data="GrantForm.files.technical.revisionAppTaxCertification"
            :is-editable="GrantForm.isRevisionEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.revisionAppTaxCertification"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.revisionAppLastActivityReport">{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_assoc_upload_title_4')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.revisionAppLastActivityReport"
            class="upload-file"
            :file-data="GrantForm.files.technical.revisionAppLastActivityReport"
            :is-editable="GrantForm.isRevisionEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.revisionAppLastActivityReport"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.revisionAppAnualFinancialStataments">{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_assoc_upload_title_5')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.revisionAppAnualFinancialStataments"
            class="upload-file"
            :file-data="GrantForm.files.technical.revisionAppAnualFinancialStataments"
            :is-editable="GrantForm.isRevisionEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.revisionAppAnualFinancialStataments"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.revisionAppCodeOfConductPolicies">{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_assoc_upload_title_6')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.revisionAppCodeOfConductPolicies"
            class="upload-file"
            :file-data="GrantForm.files.technical.revisionAppCodeOfConductPolicies"
            :is-editable="GrantForm.isRevisionEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.revisionAppCodeOfConductPolicies"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.revisionAppTimesheet">{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_assoc_upload_title_7')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.revisionAppTimesheet"
            class="upload-file"
            :file-data="GrantForm.files.technical.revisionAppTimesheet"
            :is-editable="GrantForm.isRevisionEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.revisionAppTimesheet"
            >
          </upload-file>
        </div>

        <h6 style="color: red">{{$t('small_technical_grants.document_upload__additional_info')}}</h6>

        <h4 class="card-title">{{$t('small_technical_grants.document_upload__budget_card_title')}}</h4>
        <a
          :href="downloadFiles[5][$i18n.locale]"
          class="ml-2 btn btn-simple btn-primary"
          >
          {{$t('small_technical_grants.document_upload__download_template_button_title')}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
        </a>

        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.revisionAppCompletedBudgetTable">{{$t('small_technical_grants.document_upload__budget_upload_title_1')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.revisionAppCompletedBudgetTable"
            class="upload-file"
            :file-data="GrantForm.files.technical.revisionAppCompletedBudgetTable"
            :is-editable="GrantForm.isRevisionEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.revisionAppCompletedBudgetTable"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.revisionAppQuotes">{{$t('small_technical_grants.document_upload__budget_upload_title_2')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.revisionAppQuotes"
            class="upload-file"
            :file-data="GrantForm.files.technical.revisionAppQuotes"
            :is-editable="GrantForm.isRevisionEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.revisionAppQuotes"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.revisionAppJustification">{{$t('small_technical_grants.document_upload__budget_upload_title_3')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.revisionAppJustification"
            class="upload-file"
            :file-data="GrantForm.files.technical.revisionAppJustification"
            :is-editable="GrantForm.isRevisionEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.revisionAppJustification"
            >
          </upload-file>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <h4 class="card-title">{{$t('small_technical_grants.document_upload__other_documents_card_title')}}</h4>
        <p>{{$t('small_technical_grants.document_upload__other_documents_info')}}</p>
        <table class="mt-5 mb-2" width="100%">
          <thead>
            <th>Name</th>
            <th>Upload</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in GrantForm.revisionModel.technical.otherDocuments" :key="'result_'+index">
              <td>
                <textarea
                  class="form-control"
                  :placeholder="$t('small_technical_grants.document_upload__other_documents_placeholder')"
                  v-model="item.result"
                >
                </textarea>
              </td>
              <td>
                <upload-file
                  v-if="GrantForm.initialized"
                  v-model="GrantForm.files.technical['revisionOtherDocuments' + (index+1)]"
                  class="upload-file"
                  :file-data="GrantForm.files.technical['revisionOtherDocuments' + (index+1)]"
                  :is-editable="GrantForm.isRevisionEditable"
                  :size-limit="GrantForm.fileSizeLimit"
                  :section="'technical.revisionOtherDocuments' + (index + 1)"
                  >
                </upload-file>
              </td>
            </tr>
          </tbody>
        </table>

        <base-button
          type="primary"
          @click.native="addOtherDocument"
          class="ml-2"
          >
          <i class="tim-icons icon-simple-add mr-2"></i> {{$t('small_technical_grants.logical_framework__add_row_button_title')}}
        </base-button>
        <span class="ml-3">{{$t('small_technical_grants.logical_framework__add_row_button_info')}}</span>
      </div>
    </div>

  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm,
        downloadFiles: [
          {
            en: '/files/en/STG/Region/'+GrantForm.regionId+'/1.BIOPAMA_STG_Application_Template.docx',
            fr: '/files/fr/STG/Region/'+GrantForm.regionId+'/1.BIOPAMA_STG_Formulaire_de_demande.docx'
          },
          {
            en: '/files/en/STG/Region/'+GrantForm.regionId+'/2.BIOPAMA_STG_Applicant_Declaration.docx',
            fr: '/files/fr/STG/Region/'+GrantForm.regionId+'/2.BIOPAMA_STG_Declaration_du_demandeur.docx'
          },
          {
            en: '/files/en/STG/Region/'+GrantForm.regionId+'/3.BIOPAMA_Co-Applicant_Mandate.docx',
            fr: '/files/fr/STG/Region/'+GrantForm.regionId+'/3.BIOPAMA_STG_Mandat_du_co-candidat.docx'
          },
          {
            en: '/files/en/STG/Region/'+GrantForm.regionId+'/4.BIOPAMA_STG_ESMS questionnaire.docx',
            fr: '/files/fr/STG/Region/'+GrantForm.regionId+'/4.BIOPAMA_STG_Questionnaire_SGES.docx'
          },
          {
            en: '/files/en/STG/Region/'+GrantForm.regionId+'/5.BIOPAMA_STG_Due_Diligence_Questionnaire.docx',
            fr: '/files/fr/STG/Region/'+GrantForm.regionId+'/5.BIOPAMA_STG_Questionnaire_de_capacite.docx'
          },
          {
            en: '/files/en/STG/Region/'+GrantForm.regionId+'/6.BIOPAMA_AC_STG_Budget_EN.xls',
            fr: '/files/fr/STG/Region/'+GrantForm.regionId+'/6.BIOPAMA_STG_Petites_Subvention_Technique_Budget_FR.xls'
          },
        ]
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
      addOtherDocument()
      {
        if (!GrantForm.revisionModel.technical.otherDocuments)
        {
          GrantForm.revisionModel.technical.otherDocuments = [];
        }

        GrantForm.revisionModel.technical.otherDocuments.push({});
        this.$forceUpdate();
      },
      mounted()
      {
        this.addOtherDocument();
      },
    }
  }
</script>
<style lang="scss" scoped>
.table-bordered td,
.table-bordered th
{
  padding: 20px;
}

.file-caption
{
  margin-right: 10px;
  display: inline-block;
  width: 60%;
}

.upload-file
{
  display: inline-block;
  margin-bottom: -4px;
}

.form-group
{
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 15px;
}

.card-title
{
  display: inline-block;
  width: 54.3%;
  margin-bottom: 1.75rem !important;
}
</style>
